import { z } from 'zod';

export const CreateClaimReversalSchema = z.object({
  invoiceNumber: z.string(),
});

export type CreateClaimReversal = z.infer<typeof CreateClaimReversalSchema>;

export type SubmitClaimReversalRequest = CreateClaimReversal;
